module.exports = __webpack_public_path__ + "static/media/5.da872eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/5.jpg
// module id = 396
// module chunks = 0